const Form084EN = {
    stepName: {
        importantNotes: "Important Notes",
        supplementary: "Supplementary Sheet\n(To be completed by the teacher)",
        regrading: "Regrading to Graduate Teachers",
        certification: "Certification",
        confirmation: "Confirmation",
        detailsOfRegrading: "Details of Regrading",
        approverCertification: "Certification",
        annex: "Annex for Staff Establishment and Strength Table",
        formA: "Certification",
        schoolOfInformation:
            "School Admin fill in the form of Regarding to Gradated Teacher in Secondary School",
        formB: "Basic Information",
    },
    label: {
        statement:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        title: "Personal Information Collection Statement",
        collectionStatement: "Personal Information Collection Statement",
        supplementary:
            "Supplementary Sheet for Regrading to Graduate Teachers in Secondary Schools",
        schoolOfInformation: "Basic Information",
        detailsOfRegrading: "Details of Regrading",
        certification: "Certification",
        schoolName: "School Name",
        schoolCode: "School Code",
        schoolSession: "School Session",
        contactPerson: "Contact Person",
        tel: "Telephone Number",
        contactAndTelText1: "School's contact person",
        contactAndTelText2: "and tel. no.",
        contactAndTelText3: "(for enquiry by EDB in processing this form)",
        committee: "Committee",
        committeeOption: {
            smc: "School Management Committee",
            imc: "Incorporated Management Committee",
        },
        mode: " has approved the following acting appointment",
        ref: "Reference Number",
        date: "Date",

        personal: "Personal Particulars",
        Teachertitle: "Title",
        titleOp: {
            Mr: "Mr",
            Miss: "Miss",
            Mrs: "Mrs",
            Ms: "Ms",
        },

        staffRef: "Staff Reference Number",
        appointment: "Appointment Particulars",
        appointment2:
            " (Use a separate sheet if necessary. For non-local academic qualifications and/or professional training, provide the assessment resultsand/or other relevant details.)",
        college: "College/University/Institute",
        certificate: "Certificate/Diploma/Degree obtained",
        dateOfAward: "Date of Award (yyyy)",
        dateOfAward2: "Date of Award (mm)",
        dateOfAward3: "Date of Award (dd)",
        major: "Major & Minor Subject(s)",
        school: "School/College/University/Institute",
        course: "Course/Subject",
        institute: "School/Institute",
        type: "Type",
        rank: "Rank",
        dateFrom: "From (dd/mm/yyyy)",
        dateTo: "To (dd/mm/yyyy)",
        fullOrPart: "Full- or Part-time",
        fullOrPartOp: {
            fullTime: "Full-time",
            partTime: "Part-time",
        },
        sourceOfFunding: "Source of Funding",
        signatureOfTeacher: "Signature of Teacher",
        ssdo: "Respective Regional Education Office [Attn : ",
        ssdo2: "] Education Bureau",
        ssdoLabel: "SSDO",
        committeeText1: "1. The *",
        committeeText2: "has approved the following regrading (Ref. No.",
        committeeText3: "and Date:",
        committeeText4: ")",
        committeeText5: " and the consequential change in salary particulars:",
        changesInSalaryDetails: "Acting Appointment Details",
        englishName: "Name of Teacher in English",
        chineseName: "Name of Teacher in Chinese",
        hkid: "HKIC No.",
        srn: "SRN",
        englishName2: "Name in English",
        chineseName2: "Name in Chinese",
        hkid2: "HK Identity Card No.",
        srn2: "Staff Reference Number",
        monthlySalaryBeforeRegrading:
            "Monthly Salary (MPS point) Before Regrading",
        rankBeforeRegrading: "Rank Before Regrading",
        monthlySalaryUponRegrading: "Monthly Salary (MPS point) Upon Regrading",
        rankUponRegrading: "Rank Upon Regrading",
        effectiveDate: "Effective Date (dd/mm/yyyy):",
        incrementalDate: "Incremental Date (01/mm)",
        nextIncrementDate: "Date of Next Increment (01/mm/yyyy)",
        salaryBar: "Salary Bar (if applicable) (MPS Pt.)",
        maximumSalary: "Maximum Salary (MPS Pt.)",
        annex: "2. The Staff Establishment and Strength Table at the ",
        annex2: "Annex",
        annex3: " indicates that a vacancy is available for the above regrading.",
        confirm:
            "3. I confirm that the particulars in paragraphs 1 to 2 of this form and the supplementary sheet are correct. I undertake that the regrading will not result in having the number of graduate teacher in excess of our graduate post entitlement. I also undertake that my school shall refund any over-payment of Salaries Grant to the Education Bureau.",
        pointOption: {
            na: "NA",
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46(44B)",
            fortyFive: "45(44A)",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36(33C)",
            thirtyFive: "35(33B)",
            thirtyFour: "34(33A)",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        confirmBtn: "Confirm",
        supervisorOrSchoolHead: "Supervisor / School Head",
        supervisorOrSchoolHeadOption: {
            supervisor: "Supervisor",
            schoolHead: "School Head",
        },
        iamStatement:
            "I understand that an “iAM Smart+” account is required for processing the application.",
        chooseTheSchool:
            "Annex for School (For Ordinary Secondary School/ For Special School)",
        chooseTheSchoolOption: {
            secondarySchool: "Secondary School",
            specialSchool: "Special School",
        },
        nameDescription: "Name (as printed on HK Identity Card)",
    },
    monthOption: {
        jan: "0",
        feb: "1",
        mar: "2",
        apr: "3",
        may: "4",
        jun: "5",
        jul: "6",
        aug: "7",
        sep: "8",
        oct: "9",
        nov: "10",
        dec: "11",
    },
    tabel: {
        title1: "Academic Qualifications",
        title2: "Professional Training",
        title3: "Teaching Experience",
        title4: "No-pay Leave Taken (If any)",
    },
    note: {
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        note2: "Please use one form for each regrading.",
        note3: "Please complete the Supplementary Sheet if the salary upon regrading is determined by re-assessment",
        note3a: ".",
        note4: "Please read the Personal Information Collection Statement carefully before completing this form.",
        note5: "Please ensure the content of this form and the supplementary sheet, if applicable, is made known to the teacher and he/shehas read the Personal Information Collection Statement.",

        note6: "Please specify, e.g. Aided, Govt, Private, Caput, BPS, DSS…..",
        note7: "If part-time, please state the fraction.",
        note8: "Please specify, e.g. Salaries Grant (SG), Quality Education Fund (QEF), Operating Expenses Block Grant (OEBG), Capacity Enhancement Grant (CEG), private …..",

        note9: "By re-assessment, the salary is assessed on the basis of prevailing starting salaries plus incremental credits for experience (ICE), if applicable.",
        note10: "All the necessary procedures for regrading should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of regrading.",
        note11: "EDB will perform pre-processing entitlement checking on each regrading. If the regrading of teacher would exceed the approved entitlement of teaching staff of the school on the relevant regrading date, no Salaries Grant with respect to that regrading will be paid to the school until the regrading is confirmed in order.",

        note16: "(a) processing employment-related matters;",
        note17: "(b) processing payment of Salaries Grant and other government funding;",
        note18: "(c) calculation of provident fund contribution;",
        note19: "(d) auditing;",
        note20: "(e) conducting research and compiling statistics to facilitate planning of education services;",
        note21: "(f) processing matters relating to the development of the education profession;",
        note26: "(g) administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        note22: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note23: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        note24: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data(Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note25: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections,should be made in writing to the respective Senior School Development Officer.",
        // five page
    },
    errorMsg: {
        E0001: "Please input a valid school name",
        E0002: "Please input a valid school code",
        E0003: "Please input a valid rank before regrading",
        E0004: "Please input a valid rank upon regrading",
        E0006: "Please enter a valid file ref. No.",
        E0007: "Please input a valid contact person",
        E0008: "Monthly Salary Upon Regrading should not be greater than Maximum Salary",
        englishName: "Please input a valid name of teacher in English",
        chineseName: "Please input a valid name of teacher in Chinese",
        numberOnly: "Please input a valid number with 8 digits",
        substantiveRank: "Please input a valid substantive rank",
        rankOfActingAppointment:
            "Please input a valid rank of acting appointment",
        refNum: "Please input a valid reference number",
        digits: "{{name}} must be {{len}} digits",
        characters: "{{name}} must be {{len}} characters",
        hkidEmpty: "The value in the brackets cannot be empty",
        Note001:
            "Note 1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC.  Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appoint.",
    },
};
export default Form084EN;
